module.exports = __webpack_public_path__ + "static/media/excluir.1feba51b.svg";